import React from "react";
import { HelpCircle, Mail, Copy, Check } from "lucide-react";
import { useState } from "react";

import { Button } from "components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";

interface HelpDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

function HelpDialog({ open, onOpenChange }: HelpDialogProps) {
  const [copied, setCopied] = useState(false);
  const supportEmail = "support@healthharbor.co";

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(supportEmail);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy email:", err);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle className="flex items-center space-x-2">
            <HelpCircle className="h-5 w-5 text-[#005151]" />
            <span>Need Help?</span>
          </DialogTitle>
          <DialogDescription>
            Get in touch with our support team for assistance with your account
            or any questions you may have.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center space-y-4 py-4">
          <div className="flex items-center space-x-2 p-3 bg-gray-50 rounded-lg w-full">
            <Mail className="h-4 w-4 text-gray-600" />
            <span className="text-sm font-medium flex-1">{supportEmail}</span>
            <Button
              variant="outline"
              size="sm"
              onClick={handleCopyEmail}
              className="h-8 w-8 p-0"
            >
              {copied ? (
                <Check className="h-3 w-3 text-green-600" />
              ) : (
                <Copy className="h-3 w-3" />
              )}
            </Button>
          </div>
          <p className="text-xs text-gray-500 text-center">
            Click the copy button to copy the email address to your clipboard
          </p>
        </div>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default HelpDialog;
